<h4 class="mb-4">Client Details</h4>
<div class="row">
	<div class="col-lg-6">
		<div class="mb-3">
			<h6>Id:</h6><span>{{data.basic.id}}</span>
		</div>
		<div class="mb-3">
			<h6>Full name:</h6><span>{{data.basic.firstname + ' ' + data.basic.lastname}}</span>
		</div>
		<div class="mb-3">
			<h6>Telephone:</h6><span>{{data.extra.telephoneNumber}}</span>
		</div>
		<div class="mb-3">
			<h6>Email:</h6><span>{{data.basic.email}}</span>
		</div>
	</div>
	<div class="col-lg-6">
		<div *ngIf="data.basic.companyname" class="mb-3">
			<h6>Company:</h6><span>{{data.basic.companyname}}</span>
		</div>
		<div class="mb-3">
			<h6>Country:</h6><span>{{data.extra.country}}</span>
		</div>
		<div *ngIf="data.extra.tax_id" class="mb-3">
			<h6>Tax id:</h6><span>{{data.extra.tax_id}}</span>
		</div>
		<div *ngIf="data.extra.notes" class="mb-3">
			<h6>Notes:</h6><span>{{data.extra.notes}}</span>
		</div>
	</div>
</div>
<div class="row mb-2 no-gutters mt-3">
  <div class="col-12">
    <button mat-button class="float-right mr-2" (click)="onOkClick()" color="primary">OK</button>
  </div>
</div>
